module.exports = __webpack_public_path__ + "static/features-pilot-a5df2e922aed890091d9027c06a8e3de.png";